'use client'

import { useEffect, useRef } from 'react'

import { useLocation } from '@marketplace-web/shared/browser'
import { useCatalogContext } from '@marketplace-web/domain/catalog-page-data'

import useFetchDynamicFilters from './useFetchDynamicFilters'

const useHandleCatalogSearchTextChange = () => {
  const {
    state: {
      dynamicFilters: { selectedDynamicFilters },
      general: { filtersChangeCount },
    },
  } = useCatalogContext()
  const { searchParams } = useLocation()

  const fetchDynamicFilters = useFetchDynamicFilters()

  const filtersChangeCountRef = useRef(filtersChangeCount)
  filtersChangeCountRef.current = filtersChangeCount

  const catalogIdRef = useRef(searchParams.catalog?.[0])
  catalogIdRef.current = searchParams.catalog?.[0]

  const selectedDynamicFiltersRef = useRef(selectedDynamicFilters)
  selectedDynamicFiltersRef.current = selectedDynamicFilters

  const searchText = searchParams.search_text ? String(searchParams.search_text) : undefined

  useEffect(() => {
    if (filtersChangeCountRef.current < 1) return

    fetchDynamicFilters({
      selectedDynamicFilters: selectedDynamicFiltersRef.current,
      isSearchTextOnly: true,
    })
  }, [fetchDynamicFilters, searchText])
}

export default useHandleCatalogSearchTextChange
